<div class="adoption-page">

    <div class="adoption-header">
        <div>
          <h1>Adopciones ABAQ</h1>
          <p>
            Consulta y administra los procesos de adopción registrados.
          </p>
        </div>
      
        <button
          type="button"
          class="copy-form-button"
          (click)="copyAdoptionFormLink()"
        >
          🔗 Copiar formulario
        </button>
      </div>
  
    @if (isLoading) {
      <div class="adoption-loading">
        <p>Cargando adopciones...</p>
      </div>
    } @else if (adoptions.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">🐾</div>
  
        <h2>No hay adopciones registradas</h2>
  
        <p>
          Cuando se registre una adopción, aparecerá aquí.
        </p>
      </div>
    } @else {
  
      <div class="adoption-list">
  
        @for (adoption of pagedAdoptions; track adoption._id) {
  
          <article class="adoption-card">
  
            <div class="adoption-card-main">
  
              <div class="animal-photo">
                @if (adoption.animalPhotoUrl) {
                  <img
                    [src]="adoption.animalPhotoUrl"
                    [alt]="adoption.animalName"
                  />
                } @else {
                  <div class="animal-placeholder">
                    🐾
                  </div>
                }
              </div>
  
              <div class="animal-info">
  
                <div class="animal-title">
                  <h2>{{ adoption.animalName }}</h2>
  
                  <span class="species-badge">
                    {{ adoption.species === 'DOG' ? 'Perro' : 'Gato' }}
                  </span>
                </div>
  
                <p class="responsible-name">
                  Responsable: {{ adoption.responsibleName }}
                </p>
  
                <div class="animal-details">
  
                  <div class="detail-item">
                    <span>Género</span>
                    <strong>
                      {{ adoption.animalGender || 'No especificado' }}
                    </strong>
                  </div>
  
                  <div class="detail-item">
                    <span>Raza</span>
                    <strong>
                      {{ adoption.breed || 'No especificada' }}
                    </strong>
                  </div>
  
                  <div class="detail-item">
                    <span>Tamaño</span>
                    <strong>
                      {{ adoption.size || 'No especificado' }}
                    </strong>
                  </div>
  
                  <div class="detail-item">
                    <span>Edad</span>
                    <strong>
                      @if (adoption.animalAge !== null && adoption.animalAge !== undefined) {
                        {{ adoption.animalAge }} años
                      } @else {
                        No especificada
                      }
                    </strong>
                  </div>
  
                </div>
  
                @if (adoption.trialStartDate) {
                  <div class="trial-date">
                    <span>Inicio de prueba</span>
  
                    <strong>
                      {{ adoption.trialStartDate | date:'mediumDate':'UTC' }}
                    </strong>
                  </div>
                }
  
              </div>
  
            </div>
  
            <div class="adoption-card-actions">
  
              <button
                type="button"
                class="view-adoption-button"
                (click)="viewAdoption(adoption._id)"
              >
                Ver detalles
              </button>
  
            </div>
  
          </article>
  
        }
  
      </div>

      <app-pagination
        [(page)]="page"
        [totalItems]="adoptions.length"
        [pageSize]="pageSize"
      ></app-pagination>
  
    }
  
  </div>